import {axios} from "../../config/axios"

export const autoCampaignAPI = {
  /**
   * Retrieve all available advertisers connect to current merchant
   * @param {number} autoCampaignId - current auto campaign's id
   * @param {string} searchTerm - optional, if user enters any search terms
   */
  getBrands(currentPage, searchTerm) {
    const params = { page: currentPage }
    if (searchTerm) params.search = searchTerm
    return axios.get(`/api/v3/brands`, { params: params })
      .then(resp => resp.data)
  }
}